"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleOptions = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importStar(require("react"));
const shared_1 = require("../../shared");
const localeUtils_1 = require("../../utils/localeUtils");
const SimpleDesktopDropdownMenu_1 = require("../menu/SimpleDesktopDropdownMenu");
const LocaleIcon_1 = require("./LocaleIcon");
const pathname_1 = require("../../context/pathname");
const LocaleOptions = ({ locale, localeOptions, rightAlign }) => {
    const namedLocaleOptions = (0, shared_1.useLocaleOptionsWithNames)(localeOptions);
    const { messages } = (0, shared_1.useMessages)();
    const getMessage = (0, epic_games_nav_shared_1.useLocalization)();
    const { sortedLocaleOptions = [], currentLocaleName } = (0, localeUtils_1.getSortedLocaleOptions)(namedLocaleOptions, locale, messages.locale);
    const isLegacyLinkBehaviour = (0, epic_games_nav_shared_1.useLegacyLinkBehaviour)();
    const pathname = (0, pathname_1.usePathname)();
    const dropdownLinks = sortedLocaleOptions.map((localeOption) => {
        if (localeOption.lang && localeOption.lang !== locale) {
            const href = isLegacyLinkBehaviour ? (0, localeUtils_1.getLocaleHref)(localeOption, locale) : pathname;
            const title = (localeOption.name.indexOf('.') > -1 ? getMessage(localeOption.name) : localeOption.name) || localeOption.lang;
            const lang = localeOption.lang.replace(/_/, '-');
            return Object.assign(Object.assign({}, localeOption), { explicitLocale: true, href,
                title,
                lang, target: localeOption.target || '_self' });
        }
    });
    const summary = (0, react_1.useMemo)(() => {
        return react_1.default.createElement(LocaleIcon_1.LocaleIcon, { currentLocale: currentLocaleName });
    }, [currentLocaleName]);
    if (dropdownLinks.length === 0) {
        console.warn('LocaleOptions was passed no dropdownOptions. Double check the supportedLocales props if this is unexpected');
    }
    return (0, react_1.useMemo)(() => (react_1.default.createElement(SimpleDesktopDropdownMenu_1.SimpleDesktopDropdownMenu, { key: "simple-menu-locale", summaryNode: summary, links: dropdownLinks, dropdownAlignCenter: true, textAlignCenter: true, rightAlign: rightAlign, menuId: "locale", disableHrefTemplate: true })), [currentLocaleName, dropdownLinks]);
};
exports.LocaleOptions = LocaleOptions;
//# sourceMappingURL=LocaleOptions.js.map